import React from 'react';
import { 
  SafeAreaTop, 
  SafeAreaBottom, 
  SafeAreaHorizontal, 
  SafeAreaContent
} from './SafeAreaProvider';
import { Capacitor } from '@capacitor/core';

export const SafeAreaTest: React.FC = () => {
  const isNative = Capacitor.isNativePlatform();

  return (
    <div style={{ 
      height: '100vh', 
      display: 'flex', 
      flexDirection: 'column',
      backgroundColor: '#f0f0f0'
    }}>
      {/* Top safe area test */}
      <SafeAreaTop>
        <div style={{
          backgroundColor: '#ff6b6b',
          padding: '20px',
          textAlign: 'center',
          color: 'white',
          fontWeight: 'bold',
          fontSize: '16px'
        }}>
          🔴 TOP SAFE AREA TEST
          {isNative ? ' (NATIVE)' : ' (WEB)'}
        </div>
      </SafeAreaTop>

      {/* Scrollable content area */}
      <SafeAreaContent>
        <SafeAreaHorizontal>
          <div style={{
            padding: '20px',
            backgroundColor: '#ffffff',
            margin: '10px 0'
          }}>
          <h2>Safe Area Test Results</h2>
          <p>This content should respect safe areas on your iPhone.</p>
          <p><strong>Platform:</strong> {isNative ? 'Native (iOS)' : 'Web'}</p>
          
          <div style={{
            backgroundColor: '#4ecdc4',
            padding: '20px',
            borderRadius: '10px',
            margin: '20px 0',
            color: 'white'
          }}>
            <h3>✅ Test Instructions:</h3>
            <ul>
              <li>🔴 Red bar at top should avoid notch/status bar</li>
              <li>🟢 Green bar at bottom should avoid home indicator</li>
              <li>Content should have proper horizontal margins</li>
              <li>This content area should scroll properly</li>
              <li>No unwanted scrolling of the entire viewport</li>
            </ul>
          </div>

          <div style={{
            backgroundColor: '#ffeaa7',
            padding: '20px',
            borderRadius: '10px',
            margin: '20px 0',
            color: '#2d3436'
          }}>
            <h3>🔧 Technical Details:</h3>
            <ul>
              <li><strong>Safe Area Provider:</strong> Active</li>
              <li><strong>Status Bar Plugin:</strong> Configured</li>
              <li><strong>CSS Environment Variables:</strong> Using env(safe-area-inset-*)</li>
              <li><strong>Viewport Control:</strong> Fixed height, overflow hidden</li>
              <li><strong>Content Scrolling:</strong> Isolated to SafeAreaContent</li>
            </ul>
          </div>

          {/* Add more content to test scrolling */}
          {Array.from({ length: 5 }, (_, i) => (
            <div key={i} style={{
              backgroundColor: '#f8f9fa',
              padding: '15px',
              margin: '10px 0',
              borderRadius: '8px',
              border: '1px solid #e9ecef'
            }}>
              <h4>Content Section {i + 1}</h4>
              <p>This is test content to verify that scrolling works properly within the safe area boundaries. The content should scroll smoothly without affecting the top and bottom safe areas.</p>
            </div>
          ))}
          </div>
        </SafeAreaHorizontal>
      </SafeAreaContent>

      {/* Bottom safe area test */}
      <SafeAreaBottom>
        <div style={{
          backgroundColor: '#51cf66',
          padding: '20px',
          textAlign: 'center',
          color: 'white',
          fontWeight: 'bold',
          fontSize: '16px'
        }}>
          🟢 BOTTOM SAFE AREA TEST
        </div>
      </SafeAreaBottom>
    </div>
  );
}; 